export interface ReleaseType {
    id: number;
    version: string;
    title: string;
    release_date: string;
    release_date_input: string | null;
    status: 'draft' | 'published';
    release_items: ReleaseItemType[];
    is_draft: boolean;
    send_email_notification?: boolean;
    email_message: number | null;
    email_sent_at: string | null;
    deleted: boolean;
}

export interface ReleaseItemType {
    id: number | null;
    uuid?: string;
    created: string | null;
    modified: string | null;
    release: number;
    title: string;
    description: string | null;
    description_plain: string | null;
    image: string | null;
    imageExample?: string | null;
    image_file?: string | null;
    image_filename?: string | null;
    image_deleted?: boolean;
    deleted: boolean;
}

export const createNewReleaseItem = (releaseId: number, uuid: string): ReleaseItemType => ({
    id: null,
    uuid: uuid,
    created: null,
    modified: null,
    release: releaseId,
    title: '',
    description: null,
    description_plain: null,
    image: null,
    deleted: false
})